/**
 * Auth Module
 */
/* eslint-disable */
import Nprogress from 'nprogress'
import VueNotifications from 'vue-notifications'
import router from '../../../router'

import Vue from 'vue'
import { isTokenExpired } from '@/auth/jwtHelper'
import profile from './profile'
import _ from 'lodash/lodash.min.js'
import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'


var isDebug = false
const state = {
    user: localStorage.getItem('userId'),
    isUserSigninWithAuth0: Boolean(localStorage.getItem('isUserSigninWithAuth0')),
    accessToken: null,
    authenticated: false,
    authResult: null,
    coronerUserDto: null,
    profile: null
}

// getters
const getters = {
    getUser: state => {
        return state.user;
    },
    isUserSigninWithAuth0: state => {
        return state.isUserSigninWithAuth0;
    },
    coronerUserDto: state => {
        return state.coronerUserDto
    },
    authProfile: state => {
        return state.profile.authProfile
    }
}

// actions
const actions = {
    authenticated ({ dispatch, commit }, authResult) {
        loggingService.log(isDebug, 'auth', 'auth.authenticated - ' + state.authenticated)
        //authResult is not being passed properly, grabbing authResult from localStorage instead
        //authResult = JSON.parse(localStorage.getItem('authResult'))
        if (authResult) {
            commit('setAuthResult', authResult)
            commit('setAccessToken', authResult.accessToken)
        }
        return new Promise((resolve, reject) => {
            var profilePromise = dispatch('profile/getProfile').then(value => {
                loggingService.log(isDebug, 'auth', 'auth.authenticated.dispatch.profile.getProfile.then')
            }, err => {
                reject(err)
            })

            var coronerUserPromise = userService.getCurrentCoronerUserDto(Vue.prototype.$http).then(response => {
                loggingService.log(isDebug, 'auth', 'auth.userService.GetCurrentCoronerUserDto')
                commit('setCoronerUserDto', response.data)
            }, err => {
                reject(err)
            })

            Promise.all([profilePromise, coronerUserPromise]).then(results => {
                loggingService.log(isDebug, 'auth', 'authenticated - post promises')
                resolve(results)
                dispatch('verifyAuth')
                loggingService.log(isDebug, 'auth', 'auth.authenticated - post promises - ' + state.authenticated)
            }, err => {
                reject(err)
            })
        })
    },
    logout ({ dispatch, commit }) {
        commit('setAccessToken', null)
        commit('setAuthResult', null)
        commit('profile/setProfile', null)
        commit('setCoronerUserDto', null)
        commit('setAuth', false)
    },
    verifyAuth ({ state, commit }) {
        if (_.isEmpty(state.authResult.idToken)) {
            commit('setAuth', false)
        } else {
            const tokenExpired = isTokenExpired(state.authResult.idToken)
            commit('setAuth', !tokenExpired)
        }
        loggingService.log(isDebug, 'auth', 'auth.verifyAuth - ' + state.authenticated)
    },
    signInUserWithAuth0 (context, payload) {
        context.commit('signInUserWithAuth0Success', payload);
    },
    signOutUserFromAuth0 (context) {
        context.commit('signOutUserFromAuth0Success');
    }
}

// mutations
const mutations = {
    setAccessToken(state, token) {
        state.accessToken = token
    },
    setAuth(state, value) {
        state.authenticated = value
    },
    setAuthResult(state, value) {
        state.authResult = value
    },
    setCoronerUserDto(state, value) {
        state.coronerUserDto = value
    },
    loginUser(state) {
        Nprogress.start();
    },
    loginUserSuccess(state, user) {
        state.user = localStorage.setItem('userId', user);
        state.isUserSigninWithAuth0 = false
        router.push("/default/dashboard/ecommerce");
        VueNotifications.success({ message: 'User Logged In Success!' });
    },
    loginUserFailure(state, error) {
        Nprogress.done();
        VueNotifications.error({ message: error });
    },
    logoutUser(state) {
        state.user = null
        localStorage.removeItem('userId');
        router.push("/session/login");
    },
    signUpUser(state) {
        Nprogress.start();
    },
    signUpUserSuccess(state, user) {
        state.user = localStorage.setItem('userId', user);
        router.push("/default/dashboard/ecommerce");
        VueNotifications.success({ message: 'Account Created!' });
    },
    signUpUserFailure(state, error) {
        Nprogress.done();
        VueNotifications.error({ message: error.message });
    },
    signInUserWithAuth0Success(state, user) {
        state.user = localStorage.setItem('userId', user);
        state.isUserSigninWithAuth0 = true;
    },
    signOutUserFromAuth0Success(state) {
        state.user = null
        localStorage.removeItem('userId')
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
    modules: {
        profile: profile
    }
}
